module.exports = __webpack_public_path__ + "img/sync-black.911d7996.svg";